import { InjectionToken } from "@angular/core";

export const PERMISSION_MAPPING = new InjectionToken<PermissionMapping>('permissions');

export interface PermissionMapping {
  [key: string]: string[];
}
